// Thin wrappers around GTM dataLayer + Meta Pixel. No-ops until the tags are
// present (i.e. until GTM_ID / META_PIXEL_ID env vars are set on the server).

type DataLayer = Array<Record<string, unknown>>
interface Win {
  dataLayer?: DataLayer
  fbq?: (...args: unknown[]) => void
}

function w(): Win {
  return window as unknown as Win
}

export function trackPageView(url: string) {
  w().dataLayer?.push({ event: 'page_view', page_path: url })
  w().fbq?.('track', 'PageView')
}

export function trackPurchase(value: number, orderNumber: string) {
  w().dataLayer?.push({
    event: 'purchase',
    value,
    currency: 'DZD',
    order_number: orderNumber,
  })
  w().fbq?.('track', 'Purchase', { value, currency: 'DZD' })
}

export function trackAddToCart(value: number, name: string) {
  w().dataLayer?.push({ event: 'add_to_cart', value, currency: 'DZD', item_name: name })
  w().fbq?.('track', 'AddToCart', { value, currency: 'DZD', content_name: name })
}
